import { gql } from '@apollo/client';
const REMOVE_CONVERSATION_MEMBER = gql `
  mutation RemoveConversationMember($conversationId: ID!, $userId: ID!) {
    removeConversationMember(conversationId: $conversationId, userId: $userId) {
      removed
    }
  }
`;
export default REMOVE_CONVERSATION_MEMBER;
